const apiConfigs = {
  "regional": {
    "apiHost": "https://api-test.mit.edu",
    "paths": {
      "account": "account-v2",
      "digitalId": "digital-id-v1"
    }
  },
  "global": {
    "apiHost": "https://account-admin-test.mit.edu/api",
    "paths": {
      "account": "account/v2",
      "digitalId": "digital-id/v1"
    }
  }
};
export default apiConfigs;